import { Anchor, Button, PasswordInput, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { NavBarContainer } from "./NavBarContainer";
import { ApiError, RestApi } from "../shared/RestApi";

export function ResetPasswordPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const email = params.get("email") ?? "";
  const token = params.get("token") ?? "";

  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);
  const [done, setDone] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await RestApi.localAuthReset(email, token, password);
      setDone(true);
    } catch (err) {
      const message =
        err instanceof ApiError ? err.message : t("resetPassword.error");
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  const missingParams = !email || !token;

  return (
    <NavBarContainer>
      <Stack gap="md" maw={480}>
        <Title order={3}>{t("resetPassword.title")}</Title>
        {missingParams ? (
          <Text c="red">{t("resetPassword.invalidLink")}</Text>
        ) : done ? (
          <>
            <Text>{t("resetPassword.success")}</Text>
            <Button component={Link} to="/signin">
              {t("resetPassword.signIn")}
            </Button>
          </>
        ) : (
          <form onSubmit={onSubmit}>
            <Stack gap="sm">
              <Text size="sm" c="dimmed">
                {email}
              </Text>
              <PasswordInput
                label={t("resetPassword.password")}
                description={t("resetPassword.passwordHint")}
                autoComplete="new-password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
              />
              {error ? (
                <Text c="red" size="sm">
                  {error}
                </Text>
              ) : null}
              <Button type="submit" loading={submitting}>
                {t("resetPassword.submit")}
              </Button>
            </Stack>
          </form>
        )}
        <Anchor component={Link} to="/signin">
          {t("resetPassword.backToSignIn")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}
